/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stat_PointsInputs */

const th_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แต้ม`)
};

const en_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points`)
};

const ja_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得点`)
};

const zh_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得分`)
};

const es_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntos`)
};

const pt_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontos`)
};

const id_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poin`)
};

const fr_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points`)
};

const tl_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntos`)
};

const vi_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điểm`)
};

const ko_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`득점`)
};

const de_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punkte`)
};

const ru_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очки`)
};

const tr_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sayı`)
};

const it_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punti`)
};

const pl_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punkty`)
};

const uk_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очки`)
};

const hi_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंक`)
};

const ar_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النقاط`)
};

const ms_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mata`)
};

const bn_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পয়েন্ট`)
};

const zh_tw2_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得分`)
};

const zh_hk2_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得分`)
};

const ur_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پوائنٹ`)
};

const fa_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`امتیاز`)
};

const sw_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pointi`)
};

const nl_stat_points = /** @type {(inputs: Stat_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punten`)
};

/**
* | output |
* | --- |
* | "Points" |
*
* @param {Stat_PointsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const stat_points = /** @type {((inputs?: Stat_PointsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stat_PointsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_stat_points(inputs)
	if (locale === "ja") return ja_stat_points(inputs)
	if (locale === "zh") return zh_stat_points(inputs)
	if (locale === "es") return es_stat_points(inputs)
	if (locale === "pt") return pt_stat_points(inputs)
	if (locale === "id") return id_stat_points(inputs)
	if (locale === "fr") return fr_stat_points(inputs)
	if (locale === "tl") return tl_stat_points(inputs)
	if (locale === "vi") return vi_stat_points(inputs)
	if (locale === "ko") return ko_stat_points(inputs)
	if (locale === "de") return de_stat_points(inputs)
	if (locale === "ru") return ru_stat_points(inputs)
	if (locale === "tr") return tr_stat_points(inputs)
	if (locale === "it") return it_stat_points(inputs)
	if (locale === "pl") return pl_stat_points(inputs)
	if (locale === "uk") return uk_stat_points(inputs)
	if (locale === "hi") return hi_stat_points(inputs)
	if (locale === "ar") return ar_stat_points(inputs)
	if (locale === "ms") return ms_stat_points(inputs)
	if (locale === "bn") return bn_stat_points(inputs)
	if (locale === "zh-TW") return zh_tw2_stat_points(inputs)
	if (locale === "zh-HK") return zh_hk2_stat_points(inputs)
	if (locale === "ur") return ur_stat_points(inputs)
	if (locale === "fa") return fa_stat_points(inputs)
	if (locale === "sw") return sw_stat_points(inputs)
	if (locale === "nl") return nl_stat_points(inputs)
	return en_stat_points(inputs)
});